<script setup lang="ts">
import { toasts } from '/@utilities/toast';
</script>

<template>
  <teleport to="#toasts">
    <div class="app-toast is-dark" v-for="toast in toasts" :key="toast.id">
      <div class="app-toast__text">
        {{ toast.message }}
      </div>

      <button
        class="app-toast__action"
        v-for="action in toast.actions"
        :key="action.label"
        v-on:click="action.onClick(toast)"
      >
        {{ action.label }}
      </button>

      <button class="app-toast__action" v-on:click="toast.close()" v-if="!toast.persistent">
        <df-icon code="f00d" />
      </button>
    </div>
  </teleport>
</template>

<style scoped>
.app-toast {
  padding: var(--gap-sm);
  padding-left: var(--gap-md);
  border-radius: var(--radius-sm);
  background-color: var(--color-cardbg);
  color: var(--color-text);
  display: grid;
  gap: var(--gap-sm);
  grid-template-columns: 1fr;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
}

.app-toast__action {
  background-color: transparent;
  padding: var(--gap-sm);
  border: none;
  font: inherit;
  color: var(--color-link);
  border-radius: var(--radius-sm);
  font-weight: 600;
  text-transform: uppercase;

  &:hover {
    background-color: var(--color-hover);
  }
}
</style>
